export const AT_STATUS_SET = 'HINT_STATUS_SET';
export const AT_STEP_SET = 'HINT_STEP_SET';
export const AT_CAN_SHOW_SET = 'HINT_CAN_SHOW_SET';
